import React from 'react';
import { useAPIContext } from '../../../context/api';
import { BrandsAPI } from '../../../../../constructs/brands/interface';
import { FeedbackRating } from '../../../../../types/brands/feedback';

export const useSubmitBannerFeedback = () => {
  const { callEndpoint } = useAPIContext();

  const submitBannerFeedback = React.useCallback(
    async (bannerId: string, rating: FeedbackRating, comment?: string) => {
      try {
        const res = await callEndpoint<BrandsAPI, 'submit-banner-feedback'>(
          'brands',
          `/banners/${bannerId}/feedback`,
          'POST',
          {
            feedback: { rating, comment }
          }
        );

        return res;
      } catch (error) {
        console.error('Error updating banner feedback:', error);
      }
    },
    [callEndpoint]
  );

  return { submitBannerFeedback };
};
